export default __webpack_public_path__ + "static/media/err-bg.4ec19841.png";